import { z } from 'zod'

const TravelerContactResponse = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  phone: z.string(),
})

export const schema = z.object({
  id: z.string(),
  source: z.enum(['ESCAPADA_RURAL', 'WIDGET', 'WEBSITE']),
  channel: z.enum(['EMAIL', 'WHATSAPP']),
  ownerId: z.string(),
  traveler: TravelerContactResponse,
  cottageId: z.string(),
  message: z.string(),
  createdAt: z.string().nullable(),
})

export type schemaType = z.infer<typeof schema>
